import { Amount, ICurrency, normalizeAmounts } from '@akropolis-web/primitives';

export function normalizeAmount(amount: Amount<ICurrency>, decimals: number) {
  return normalizeAmounts([amount], decimals)[0].value;
}
